import Image from 'next/image';
import { trackGoogleAnalyticsEvent } from '../lib/googleAnalytics';

const CIRCLE_ALERT_URL = 'https://circlealert.app.link/invitd-ad';

export default function CircleAlertAdvertisement() {
  const trackAdClick = () => {
    trackGoogleAnalyticsEvent('circlealert_ad_click', {
      ad_name: 'circlealert',
      ad_placement: 'event_details',
      destination_url: CIRCLE_ALERT_URL,
    });
  };

  return (
    <aside
      aria-label="Advertisement"
      className="overflow-hidden rounded-xl border border-orange-100 bg-white shadow-sm"
    >
      <div className="border-b border-gray-100 bg-gray-50/80 px-4 py-2 text-center text-[10px] font-semibold uppercase tracking-[0.18em] text-gray-400">
        Advertisement
      </div>
      <a
        href={CIRCLE_ALERT_URL}
        target="_blank"
        rel="noopener noreferrer sponsored"
        aria-label="Learn more about CircleAlert"
        onClick={trackAdClick}
        className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-inset"
      >
        <Image
          src="/circlealert-ad.png"
          alt="CircleAlert safety check-in advertisement"
          width={1374}
          height={1145}
          sizes="(max-width: 672px) calc(100vw - 32px), 640px"
          className="block h-auto w-full transition-opacity group-hover:opacity-95"
        />
      </a>
    </aside>
  );
}
